import angular from 'angular';
import _ from 'lodash';
import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.ticket',
    modules: [
        R,
    ],
})
@Service('TicketStore')
export default class Store extends BaseStore {
    defaultParams = {
        date: {
            startDate: null,
            endDate: null,
        },
    };

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('tickets');
        this.params = angular.copy(this.defaultParams);
    }

    resetParams () {
        this.params = angular.copy(this.defaultParams);
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/ticket.js